import { createSelector } from "reselect"
import { NORMALIZATION } from "helpers/segments"
import { getIsActive, getSelectedTypeId, getNormalization } from "./index"
import { getSegment } from "./segment"

export const getAdjustedNormalizationProperties = createSelector(
  [getIsActive, getSelectedTypeId, getSegment, getNormalization],
  (isActive, selectedTypeId, segment, normalization) => {
    if (isActive && selectedTypeId === "risk" && segment) {
      return {
        normalization: NORMALIZATION.STANDALONE,
        disableNormalization: true,
        disableNormalizationTooltip: "Segment normalization must be Standalone when active",
        isNormalizationAdjusted: true,
      }
    }

    return {
      normalization,
      disableNormalization: false,
      isNormalizationAdjusted: false,
    }
  },
)
